function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    width: 300,
    height: 300,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    width: "100%",
    height: "100%",
    transform: "matrix(1,0,0,1,0,0)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_139_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M275.806,272.347c0,0-11.985-10.182-28.647-5.163c-15.954,4.806-19.916,26.635-9.074,35.139 c6.225,4.883,15.592,8.897,28.216,13.359c28.254,9.987,17.809,49.833-10.931,50.024c-11.216,0.075-16.459-0.637-26.312-7.083",
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_138_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 256,
    y1: 365.711,
    x2: 256,
    y2: 380.54,
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_112_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 256,
    y1: 251.95,
    x2: 256,
    y2: 265.796,
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_1196_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 481.918,130.49 481.918,90.326 256,10 256,10 30.082,90.326 30.082,130.49 \t",
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_1195_",
    x: 10,
    y: 130.49,
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    width: 492,
    height: 40.163,
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1194_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M502,502H10v-10.163c0-16.569,13.431-30,30-30h432c16.569,0,30,13.431,30,30V502z",
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1193_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 60.204,
    y1: 421.673,
    x2: 60.204,
    y2: 210.816,
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1192_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 100.367,
    y1: 210.816,
    x2: 100.367,
    y2: 421.673,
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_1191_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 120.449,170.653 120.449,210.816 40.122,210.816 40.122,170.653 \t",
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_1187_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 40.122,461.837 40.122,421.673 120.449,421.673 120.449,461.837 \t",
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1186_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 411.633,
    y1: 421.673,
    x2: 411.633,
    y2: 210.816,
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("line", {
    id: "XMLID_1185_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 451.796,
    y1: 210.816,
    x2: 451.796,
    y2: 421.673,
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_1184_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 471.878,170.653 471.878,210.816 391.551,210.816 391.551,170.653 \t",
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "XMLID_1183_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    points: " 391.551,461.837 391.551,421.673 471.878,421.673 471.878,461.837 \t",
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }), /*#__PURE__*/React.createElement("circle", {
    id: "XMLID_1180_",
    style: {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    cx: 256,
    cy: 316.245,
    r: 105.429,
    fill: "none",
    fillOpacity: 1,
    stroke: "#ffffff",
    strokeOpacity: 1,
    "data-original-stroke-color": "#000000ff",
    strokeWidth: 20,
    "data-original-stroke-width": 20
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank4);
export default __webpack_public_path__ + "static/media/bank4.ad42e4b3b203fda34fcd0de5dac77281.svg";
export { ForwardRef as ReactComponent };